import { render, staticRenderFns } from "./InfoAboutAffectedCharts.vue?vue&type=template&id=7d3d08cd&scoped=true&"
import script from "./InfoAboutAffectedCharts.vue?vue&type=script&lang=ts&"
export * from "./InfoAboutAffectedCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3d08cd",
  null
  
)

export default component.exports